"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        Globalize.addCultureInfo("en", {
            messages: {
                StateMachine_StageStatus: "{0} ({1})",
            }
        });
        var StateMachineStage = /** @class */ (function (_super) {
            __extends(StateMachineStage, _super);
            function StateMachineStage(data, element, parent, role) {
                var _this = _super.call(this, data, element, parent, role) || this;
                _this.Select = function (stageIndex) {
                    _this.SelectedStageIndex(stageIndex);
                };
                _this.IsSelected = function (stageIndex) {
                    return _this.SelectedStageIndex() === stageIndex;
                };
                _this.StageText = function () {
                    var selectedStage = _this.SelectedStage();
                    if (selectedStage) {
                        return $dyn.format($dyn.label("StateMachine_StageStatus"), selectedStage.State, selectedStage.StageState.TransitionDate);
                    }
                };
                $dyn.async(function () {
                    $dyn.applyFunction(_this.LoadData, _this);
                }, undefined, "StateMachine load data");
                _this.SelectedStageIndex = $dyn.observable(0);
                _this.SelectedStage = $dyn.computed(function () {
                    var selectedStageIndex = _this.SelectedStageIndex();
                    var stages = $dyn.value(_this.Stages);
                    if (stages) {
                        return stages[selectedStageIndex];
                    }
                });
                return _this;
            }
            return StateMachineStage;
        }($dyn.ui.Control));
        controls.StateMachineStage = StateMachineStage;
        StateMachineStage.prototype.DataSourceRecId = 0;
        StateMachineStage.prototype.Label = "";
        StateMachineStage.prototype.LoadData = null;
        StateMachineStage.prototype.Stages = null;
        StateMachineStage.prototype.StateMachineName = "";
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=StateMachineStage.js.map
